import React from 'react'
import Notes from './Notes'
const Home = () => {
  document.title = "iNotebook - Home"

  return (
        <Notes/>
  )
}

export default Home
